import { STRENGTHS } from "@/data/site";
import { STRENGTHS_AR } from "@/data/content_ar";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useI18n } from "@/context/I18nContext";

export default function Strengths() {
  const { t, lang } = useI18n();
  return (
    <section id="strengths" data-testid="strengths-section" className="relative z-10 border-y border-brand-border bg-brand-soft">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-28 lg:py-40">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 lg:sticky lg:top-28 lg:self-start">
            <Reveal><Eyebrow>{t("str_eyebrow")}</Eyebrow></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight text-brand-fg leading-[1.03]">
                {t("str_title1")} <span className="text-brand-gold italic">{t("str_title2")}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}><p className="mt-6 text-brand-fg/70 text-sm leading-relaxed">{t("str_intro")}</p></Reveal>
          </div>

          <div className="lg:col-span-8">
            {STRENGTHS.map((s, i) => {
              const tr = lang === "ar" ? STRENGTHS_AR[s.n] : null;
              return (
              <Reveal key={s.n} delay={i * 0.05}>
                <div className="group grid grid-cols-[auto,1fr] gap-6 sm:gap-10 border-t border-brand-border py-10 hover:bg-brand-card transition-colors rounded-lg">
                  <div className="font-display text-4xl sm:text-6xl text-brand-fg/15 group-hover:text-brand-gold transition-colors">{s.n}</div>
                  <div>
                    <h3 className="font-display text-2xl sm:text-3xl text-brand-fg">{tr ? tr.title : s.title}</h3>
                    <p className="mt-3 max-w-xl text-brand-fg/70 leading-relaxed">{tr ? tr.body : s.body}</p>
                  </div>
                </div>
              </Reveal>
            );})}
          </div>
        </div>
      </div>
    </section>
  );
}
